import { render, staticRenderFns } from "./BroadcastRequests.vue?vue&type=template&id=7a24e884&scoped=true"
import script from "./BroadcastRequests.vue?vue&type=script&lang=js"
export * from "./BroadcastRequests.vue?vue&type=script&lang=js"
import style0 from "./BroadcastRequests.vue?vue&type=style&index=0&id=7a24e884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24e884",
  null
  
)

export default component.exports